import firebase from './firebaseConfig';
import Artist from './models/Artist';
import Project from './models/Project';

export function memberHomeURL(artistId, projectId) {
    return `/home?aid=${encodeURIComponent(btoa(artistId))}&pid=${encodeURIComponent(btoa(projectId))}`;
}

// Returns true when navigation happened; caller should not render.
export function routeMemberHome(result, navigate) {
    if (!firebase.auth().currentUser) return false;
    if (!result?.isArtistMember || !result.artistId || !result.projectId) return false;
    navigate(memberHomeURL(result.artistId, result.projectId), { replace: true });
    return true;
}

export function sharedTrackAudioFetcher(project) {
    if (!project?.isShared) return () => Promise.resolve(null);
    const fnName = project.token ? 'getSharedTrackAudioURL' : 'getSharedTrackAudioURLBySlug';
    const keyArg = project.token ? { token: project.token } : { slug: project.slug };
    return (trackId) => firebase.functions().httpsCallable(fnName)({ ...keyArg, trackId })
        .then((res) => res.data);
}

export async function buildMemberProjectFromRedeem(data) {
    const projectData = data.project || data.payload?.project || {};
    const meta = projectData.metadata || {};
    const artist = await Artist.getArtistById(data.artistId);
    const project = new Project(
        data.projectId,
        data.artistId,
        meta.name,
        meta['album art'] || null,
        meta['track count'],
        meta['duration'],
        artist,
    );
    return { artist, project };
}
